import { useNavigate } from "react-router-dom";
import AppBar from "../../components/atoms/appbar";
import SearchLayout from "../../components/layout/search";
import { useCallback } from "react";
import type { GolfParkSearchResponse } from "../../@apis/dto/response/main.response";

export default function Search() {
  const navigate = useNavigate();

  const handleSearchItemClick = useCallback(
    (item: GolfParkSearchResponse) => {
      navigate(`/store/${item.code}`);
    },
    [navigate],
  );

  return (
    <div className="bg-white flex flex-col h-full overflow-y-auto overflow-x-hidden">
      <AppBar backButton title="골프장 검색" />

      <div className="flex-1">
        <SearchLayout onClick={handleSearchItemClick} />
      </div>
    </div>
  );
}
